import React, { useEffect } from "react";
import { AdminMenu, Logout, MobileMenu } from "../../components/Admin/AdminLayout";
import { NotificationBell } from "../../components/Shared";
import { Icon, Checkbox, Button } from "semantic-ui-react";
import { useAuth, useNotifications } from "../../hooks";
import { socket } from "../../utils"; // Importa el socket
import Swal from "sweetalert2";
import "./AdminLayout.scss";

export function AdminLayout(props) {
  const { children } = props;
  const {
    user,
    accessToken,
    adminSidebarOpen,
    setAdminSidebarOpen,
    darkLightTheme,
    setDarkLightTheme,
  } = useAuth();
  const { notifications, unreadCount, reloadNotifications } =
    useNotifications();

  useEffect(() => {
    console.log("Escuchando notificaciones de post", socket);

    // Autenticar el socket y unirse a la sala del usuario
    const authenticate = () => socket.emit("authenticate", user);
    authenticate();

    // Re-autenticar tras cualquier reconexión (ej. el backend se reinició):
    // el servidor pierde la membresía a la sala `user_{id}` en cada conexión
    // nueva, así que hay que volver a unirse o dejamos de recibir pushes.
    socket.on("connect", authenticate);

    // Escucha el evento de notificación de post
    socket.on("forumNotification", (notification) => {
      console.log("Nueva notificación de post:", notification);
      // Aquí puedes manejar la notificación, por ejemplo, mostrando un mensaje al usuario
      reloadNotifications();
      Swal.fire({
        title: notification.title,
        text: notification.message,
        icon: "info",
      });
    });

    // Limpia el evento cuando el componente se desmonta
    return () => {
      socket.off("connect", authenticate);
      socket.off("forumNotification");
    };
  }, [user, accessToken, reloadNotifications]);

  const backgroundImage = darkLightTheme
    ? "url('/img/fondo_negativo.png')"
    : "url('/img/fondo.png')";

  return (
    <div className="admin-layout">
      <section
        className={`admin-layout__left ${adminSidebarOpen ? "open" : ""}`}
      >
        <AdminMenu
          darkLightTheme={darkLightTheme}
          sidebarOpen={adminSidebarOpen}
          onSidebarOpen={setAdminSidebarOpen}
        />
      </section>
      <section
        className={`admin-layout__right ${adminSidebarOpen ? "expand" : ""}`}
      >
        <div className="admin-layout__right-header">
          <MobileMenu darkLightTheme={darkLightTheme} />
          <div className="admin-layout__right-header-controls">
            <Icon
              name={darkLightTheme ? "moon" : "sun"}
              color={darkLightTheme ? "grey" : "yellow"}
              style={{ alignSelf: "center", margin: 0 }}
            />
            <Checkbox
              toggle
              checked={darkLightTheme}
              onChange={() => setDarkLightTheme(!darkLightTheme)}
              style={{ alignSelf: "center", margin: 0 }}
            />
            <NotificationBell
              unreadCount={unreadCount}
              notifications={notifications}
              onReloadNotifications={reloadNotifications}
              notificationsPath="/admin/notifications"
              postBasePath="/admin/post"
            />
            <Button
              className="admin-layout__menu-button"
                    size="big"
              color="brown"
              icon="bars"
            />
            <Logout />
          </div>
        </div>
        <div
          className="admin-layout__right-content"
          style={{
            backgroundImage: backgroundImage,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            transition: "background-image 0.4s ease-out",
          }}
        >
          {children}
        </div>
      </section>
    </div>
  );
}
